import { render, staticRenderFns } from "./segmenta-cookieHandler.vue?vue&type=template&id=3c6ab631"
import script from "./segmenta-cookieHandler.vue?vue&type=script&lang=js"
export * from "./segmenta-cookieHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports